import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './Update.module.less';
import { message } from 'antd';

import { PCStoreJsBridge } from '../../../nativeapi';
import { logging } from '../../../actions/log';
import { cacheKeys } from '../../../constants/storageKeys';
import Toast from '../../../components/Toast/Toast';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  // 是否打开自动升级商店
  const [isEnableInd, setIsEnableInd] = useState(true);
  const [rightMenuInfo, setRightMenuInfo] = useState(null);

  useEffect(() => {
    const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
    if (startInfo && startInfo.rightMenuInfo) {
      setRightMenuInfo(startInfo.rightMenuInfo);
    } else {
      // 这里设置右键菜单开关状态
      PCStoreJsBridge.getRightMenuInfo().then(res => {
        if (res.succ) {
          setRightMenuInfo(res);
        }
      });
    }
  }, []);

  // 点击 切换打开右键菜单
  const handleCheckRightMenu = useCallback(
    info => {
      const startInfo = JSON.parse(localStorage.getItem(cacheKeys.START_INFO) || '{}');
      // source: 1表示设置中心的设置，2表示关闭商店的时候的设置
      PCStoreJsBridge.settingRightMenu({
        enable: !info.enable,
        source: 1,
        wallpaperEnable: startInfo.rightMenuInfo.wallpaperEnable,
        recommendEnable: startInfo.rightMenuInfo.recommendEnable,
      }).then(ret3 => {
        if (ret3.succ === 'true') {
          setRightMenuInfo({
            ...rightMenuInfo,
            enable: !info.enable,
          });
          let Info = {
            ...startInfo,
            rightMenuInfo: {
              enable: !info.enable,
              source: 1,
              wallpaperEnable: startInfo.rightMenuInfo.wallpaperEnable,
              recommendEnable: startInfo.rightMenuInfo.recommendEnable,
              cloudEnable: true,
            },
          };
          localStorage.setItem('START_INFO', JSON.stringify(Info));
          Toast.success({
            content: '设置成功!',
          });
        } else {
          message.info('软件快捷方式右键添加“强力卸载此软件”选项，设置失败');
        }
      });

      // 点击 切换打开右键菜单
      dispatch(
        logging({
          category: 'C',
          action: 'Right_Menu_Cancel',
          label: '',
          param2: {
            source: 'Setting',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            enabled: !info.enable,
          },
        }),
      );
    },
    [logInfoData, rightMenuInfo],
  );

  return (
    <div className={styles.s_update}>
      {rightMenuInfo && rightMenuInfo.cloudEnable && (
        <div className="s_line">
          <div className="s_select_title">卸载设置：</div>
          <div className="s_content">
            <div
              className="checkbox checkbox_clear"
              onClick={() => handleCheckRightMenu(rightMenuInfo)}
            >
              {rightMenuInfo.enable ? <div className="checked" /> : <div className="no_checked" />}
              <span>软件快捷方式右键添加“强力卸载此软件”选项</span>
            </div>
            <div className="desc">
              开启后，将在快捷方式右键添加“强力卸载此软件”选项，一键强力卸载软件{' '}
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
